import type { TFunction } from 'i18next'
import { ApiError, RequestTimeoutError } from '@/core/api/http'
import { gevaKlettErrorBody, type GevaKlettErrorBody } from '../../api/gevaKlett'

export type GevaKlettFailure =
  | { kind: 'toast'; message: string; reload: boolean }
  | { kind: 'prompt'; body: GevaKlettErrorBody; reload: boolean }

export function classifyGevaKlettFailure(error: unknown, t: TFunction<'vergabeStaff'>): GevaKlettFailure {
  if (error instanceof ApiError) {
    const reload = error.status === 409
    const body = gevaKlettErrorBody(error)
    if (body) {
      return body.fehler.length === 0
        ? { kind: 'toast', message: body.meldung, reload }
        : { kind: 'prompt', body, reload }
    }
    return { kind: 'toast', message: t('gevaKlett.uploadFailed', { status: error.status }), reload }
  }
  if (error instanceof RequestTimeoutError) return { kind: 'toast', message: error.message, reload: false }
  if (error instanceof TypeError) return { kind: 'toast', message: t('gevaKlett.uploadNetwork'), reload: false }
  return { kind: 'toast', message: t('gevaKlett.malformed'), reload: false }
}

export function gevaKlettStatusFailureMessage(error: unknown, t: TFunction<'vergabeStaff'>): string {
  const body = gevaKlettErrorBody(error)
  if (body) return body.meldung
  if (error instanceof ApiError) return t('gevaKlett.statusFailed', { status: error.status })
  if (error instanceof RequestTimeoutError) return error.message
  if (error instanceof TypeError) return t('gevaKlett.statusNetwork')
  return t('gevaKlett.malformed')
}
